export const defaultOffset = 8
export const defaultDelay = 150

export const arrowDimensions = {
  width: 10,
  height: 6,
  tipRadius: 2,
}
